/**
 * LoadPageAnimate.jsx
 *
 * @Author: jruif
 * @Date: 2018/2/6 下午3:09
 */

import React from 'react';
import PropTypes from 'prop-types';
import Transition from 'react-transition-group/Transition';

class LoadPageAnimate extends React.Component {
  static propTypes = {
    // 渲染新组件后回调，例如：发送统计
    routerDidSwitch: PropTypes.func,
    animateName: PropTypes.string,
    docTitle: PropTypes.string, // 更改浏览器顶部显示标签
    animateTime: PropTypes.number,
  };

  static defaultProps = {
    animateName: 'slideUp',
    className: '',
    animateTime: 500,
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      show: false,
      nextChildren: null,
    };
    // this.setTitleAndSendStatistics();
  }

  componentDidMount() {
    const { children } = this.props;
    this.updateChildren(children);
  }

  componentWillReceiveProps(nextProps) {
    const { switchPath } = this.props;

    if (switchPath !== nextProps.switchPath) {
      window.scrollTo(0, 0);
      this.updateChildren(nextProps.children);
    }
  }

  updateChildren = children => {
    this.setState({
      show: false,
    });
    setTimeout(() => {
      this.setState(
        {
          show: true,
          nextChildren: React.isValidElement(children) ? React.cloneElement(children) : children,
        },
        () => {
          this.setTitleAndSendStatistics();
        },
      );
    }, this.props.animateTime);
  };

  setTitleAndSendStatistics() {
    const { docTitle, routerDidSwitch } = this.props;
    // const { href } = window.location;
    // 设置title & 发送统计
    document.title = `${docTitle}`;

    // 渲染新组件后回调，例如：发送统计
    routerDidSwitch && routerDidSwitch();
  }

  render() {
    const { className, animateName } = this.props;
    return (
      <Transition in={this.state.show} timeout={this.props.animateTime}>
        {status => (
          <div className={`${animateName} ${animateName}-${status} ${className}`}>{this.state.nextChildren}</div>
        )}
      </Transition>
    );
  }
}

export default LoadPageAnimate;
